var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.823 13.844h1.837a2.693 2.693 0 012.694 2.694v17.123a2.692 2.692 0 01-2.694 2.693H14.807a2.693 2.693 0 01-2.695-2.694v-2.5",
    stroke: "#E6A368",
    strokeWidth: 2.096,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.92 31.16h19.587a3.46 3.46 0 002.881-1.544l1.271-1.908a6.927 6.927 0 001.164-3.842V10.38a3.462 3.462 0 00-3.463-3.464H11.044a3.462 3.462 0 00-3.463 3.464v12.217a6.947 6.947 0 01-.73 3.098l-1.48 2.958a1.73 1.73 0 001.548 2.505z",
    stroke: "#E6A368",
    strokeWidth: 2.096,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.904 23.15h4.058M23.933 23.15v-7.572l-2.211 1.999M13.847 17.032c.24-.833.976-1.454 1.887-1.454 1.102 0 1.997.893 1.997 1.997a1.79 1.79 0 01-1.788 1.789 1.79 1.79 0 011.788 1.788 1.997 1.997 0 01-1.997 1.998c-.91 0-1.646-.62-1.887-1.454M14.502 5.186v3.463M24.891 5.186v3.463",
    stroke: "#E6A368",
    strokeWidth: 2.096,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCalendar;